<template>
	<div>
        <div :class="`desc ${getDescClass}`" :style="getDescStyle">{{getDescText}}</div>
		<div style="margin-top: 20px" class="text-center">
			<vButton @click="click" theme="primary">{{$t('global.common.update_OK',{defaultValue:'确定'})}}</vButton>
			<vButton class="margin-left-10" @click="cancel" >{{$t('global.common.operation_cancel',{defaultValue:'取消'})}}</vButton>
		</div>
	</div>
</template>
<script>
export default {
    props: {
        descStyle: String,
        descClass: String,
        descText: String
    },
	methods: {
		click() {
			this.$emit('ok')
		},
		cancel(){
			this.$emit('cancel')
		},
	},
	computed: {
        getDescClass () {
            return this.descClass
        },
        getDescText () {
            return this.descText
        },
        getDescStyle () {
            return this.descStyle
        }
	},
}
</script>